import styled from "styled-components";

export const StarWrapper = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const StarContainer = styled.span`
  color: #ffb900;
  font-size: 1.2rem;
  margin-right: 0.25rem;
`;
